import { ReportParams } from "../../system/ReportBase";

export interface IAuthState {
    userId?: string,
    userName?: string,
    roles?: string[],
    reports?: string[],
    ownedCustomReports?: { [key: string]: ReportParams },
    customReports?: { [key: string]: ReportParams },
    favouriteReports?: { [key: string]: boolean },
    isLoggedIn?: boolean,
    userChecked?: boolean,
}

const initialState: IAuthState = {
    userId: "",
    userName: "",
    roles: [],
    isLoggedIn: false,
    userChecked: false,
};

export const authReducer = (state: IAuthState = initialState, action: any): IAuthState => {
    switch (action.type) {
        case 'SET_USER':
            return {
                ...action.payload,
                isLoggedIn: !!(action.payload && action.payload.userName && action.payload.userName.length > 0)
            };
        default:
            return state;
    }
};
